export enum QUERY_PARAMS {
    category = 'category',
    isHideKYC = 'isHideKYC',
    CookieLayerMarketing = 'cookieLayer.marketing'
}
